<template>
	<modal ref="modal">
		<template #title>{{action.toUpperCase()}} MARKETING IMAGE</template>
		<template #body>
			<div class="form-floating mb-4">
				<select v-model="form.category" id="category" name="category" class="form-control" placeholder="Category">
					<option value="SILVER">SILVER</option>
					<option value="GOLD">GOLD</option>
					<option value="DIAMOND">DIAMOND</option>
					<option value="PLATINUM">PLATINUM</option>
					<option value="PLATINUM COUPLE">PLATINUM COUPLE</option>
					<option value="PLATINUM FAITHFUL">PLATINUM FAITHFUL</option>
				</select>
				<label class="form-label" for="category">Category</label>
			</div>
			<div class="form-floating mb-4">
				<input v-model="form.title" type="text" id="title" name="title" class="form-control" placeholder="Title" />
				<label class="form-label" for="title">Title</label>
			</div>
			<div class="form-floating mb-4">
				<input v-model="form.description" type="text" id="description" name="description" class="form-control" placeholder="Description" />
				<label class="form-label" for="description">Description</label>
			</div>
			<div class="form-floating mb-4">
				<input v-model="form.image_name" type="text" id="image_name" name="image_name" class="form-control" placeholder="Image Name" />
				<label class="form-label" for="image_name">Image Name</label>
			</div>
			<div class="form-floating mb-4">
				<select v-model="form.status" id="status" name="status" class="form-control" placeholder="Status">
                  <option value="1">ON</option>
                  <option value="0">OFF</option>
                </select>
				<label class="form-label" for="status">Status</label>
			</div>

		</template>
		<template #footer>
			<button 
				@click="actionContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing"
			>
				<span v-if="!form.processing"><i class="fa fa-save me-2"></i><span v-if="action=='add'">Add</span><span v-else>Update</span> Marketing Image</span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}
		
		const action = ref('add');

		const form = useForm({
			id 				: 0,
			category 		: '',
			title 			: '',
			description 	: '',
			image_name 		: '',
			status 			: '0'
		})

		const actionContent = ()=>{

			if(action.value=='add')
			{
				addMarketingImage();
			}else
			{
				updateMarketingImage();	
			}

		}

		const addMarketingImage = () => {
			form.post(route('admin.affiliate-program.post-marketing-image'), {
				preserveState: true,
				preserveScroll: true,
				only:['marketingImages,api_response','search'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const updateMarketingImage = () => {
			form.put('marketing-image/'+form.id, {
				preserveState: true,
				preserveScroll: true,
				only:['marketingImages,api_response','search'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const setMarketingVideoContent = (_action,data)=>{
								
								form.reset();

								action.value = _action;

								if(_action=='update')
								{
									form.id 			= data.id;
									form.category 		= data.category;
									form.title 			= data.title;
									form.description 	= data.description;
									form.image_name 	= data.image_name;
									form.status 		= data.status;
								}
								
							}


		return {
			form,
			modal,
			toggleModal,
			action,
			setMarketingVideoContent,
			actionContent,
			addMarketingImage,
			updateMarketingImage,
		}
	},
}
</script>
